import applyBlockDepthDelta from './applyBlockDepthDelta';
import { TFlatBlock } from './blocksToFlatDocument';

export default function pluckApplyDepth(flatBlocks: TFlatBlock[], blockId: string, depth: number) {
  const result: TFlatBlock[] = [];
  let index = flatBlocks.findIndex((b) => b.id === blockId);
  if (index < 0) {
    return result;
  }
  const oldDepth = flatBlocks[index].depth;
  const delta = depth - oldDepth;
  result.push(applyBlockDepthDelta(flatBlocks[index], delta));
  index++;
  while (index < flatBlocks.length && flatBlocks[index].depth > oldDepth) {
    result.push(applyBlockDepthDelta(flatBlocks[index], delta));
    index++;
  }
  return result;
}
